import axios from 'axios';
import { interceptorResponse } from './interceptor';
// Integração com Stargate API

const handleAxiosProperties = () => {
  const jwtToken = sessionStorage.getItem('user');

  const isProd = process.env.currentEnv === 'prd';

  const finalProperties = {
    timeout: isProd ? 30000 : 40000,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  };

  if (jwtToken) {
    finalProperties.headers.Authorization = `Bearer ${jwtToken}`;
  }

  return finalProperties;
};

export const checkinApi = () => {
  const instance = axios.create({
    baseURL: process.env.vueAppStargateUrl || 'http://localhost:5050',
    ...handleAxiosProperties(),
  });

  // request interceptor to provide data to telemetry
  instance.interceptors.request.use(interceptorResponse);

  return instance;
};
